var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediaplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.3333V6.66663C5 5.78706 5 5.34728 5.18509 5.08704C5.34664 4.8599 5.59564 4.71053 5.87207 4.67487C6.1885 4.63406 6.57572 4.84058 7.35036 5.25372L7.35254 5.25488L17.3525 10.5882C18.212 11.0466 18.6418 11.2758 18.7826 11.581C18.9053 11.8469 18.9053 12.1531 18.7826 12.4189C18.6418 12.7241 18.212 12.9534 17.3525 13.4117L7.35254 18.7451L7.34978 18.7465C6.57553 19.1595 6.18842 19.3659 5.87207 19.3251C5.59564 19.2895 5.34664 19.1401 5.18509 18.913C5 18.6527 5 18.2129 5 17.3333Z",
    stroke: "#00263A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaplay);
export default __webpack_public_path__ + "static/media/mediaplay.47d14a421e32bdea182c42ef31287036.svg";
export { ForwardRef as ReactComponent };